// Locale-aware formatting helpers. Client-side only.

const localeMap = { en: "en-US", nl: "nl-NL", de: "de-DE", ar: "en-US" };
// Arabic uses Western digits for financial clarity (arab-ext digits can confuse).

export const toIntlLocale = (lng) => localeMap[lng] || "en-US";

export const formatPrice = (value, currency = "USD", lng = "en", opts = {}) => {
  if (value == null || isNaN(value)) return "—";
  const digits =
    Math.abs(value) >= 1000 ? 0 : Math.abs(value) >= 1 ? 2 : value < 0.01 ? 6 : 4;
  return new Intl.NumberFormat(toIntlLocale(lng), {
    style: "currency",
    currency,
    minimumFractionDigits: opts.min ?? digits,
    maximumFractionDigits: opts.max ?? digits,
  }).format(value);
};

export const formatNumber = (value, lng = "en", digits = 2) => {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat(toIntlLocale(lng), {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  }).format(value);
};

export const formatCompact = (value, currency = "USD", lng = "en") => {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat(toIntlLocale(lng), {
    style: "currency",
    currency,
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatPercent = (value, lng = "en") => {
  if (value == null || isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${new Intl.NumberFormat(toIntlLocale(lng), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)}%`;
};

export const formatTime = (iso, lng = "en") => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat(toIntlLocale(lng), {
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "short",
    }).format(new Date(iso));
  } catch {
    return "—";
  }
};

export const changeColor = (value) =>
  value > 0 ? "text-bullish" : value < 0 ? "text-bearish" : "text-neutral";
